module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2022_de-2b2f221e2eb411e0ead335208438a5b0.jpg";